import React from 'react';
import AuthLayout from '../components/Auth/LoginAuth';
import LoginForm from '../components/Auth/LoginForm';
import Footer from '../components/Auth/Footer';

const LoginPage = () => {

    return (
        <AuthLayout>
            <LoginForm />
            <Footer />
      </AuthLayout>
    );
};

export default LoginPage;
